import * as PropTypes from 'prop-types';

import {InstitutionGraphQL} from '../../graphql-fragments/institutions/__generated/InstitutionGraphQL';

// Stripping __typename manually here instead of using WithoutTypenames because the latter does not handle
// arrays of primitives and InstitutionGraphQL has arrays of strings
export type Institution = Omit<InstitutionGraphQL, '__typename'>;

const InstitutionConstants = {
  PropTypes: {
    institution: PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      shortName: PropTypes.string.isRequired,
      names: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      verified: PropTypes.bool.isRequired,
      urlIdentifier: PropTypes.string,
      licensed: PropTypes.bool.isRequired,
    }),
  },
  USER_SUPPLIED_ID_PREFIX: 'inst_user:',
};

export default InstitutionConstants;
